module.exports = __webpack_public_path__ + "static/img/service_passprime_icon_2.4fbe7f28.svg";